/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TWebDeleteFavoritesModel,
  IWebDeleteFavoritesRequest,
  IMappers,
  IWebDeleteFavoritesResponse,
  IWebDeleteFavoritesResponseError,
  TWebDeleteFavoritesResponse,
} from './types';

const defaultConfig: TWebDeleteFavoritesModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'favorites',
  pathApi: '/v1/web/delete-favorites/',
  hostType: 'api',
} as TWebDeleteFavoritesModel;

function createWebDeleteFavoritesModel(parameters: IWebDeleteFavoritesRequest): TWebDeleteFavoritesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IWebDeleteFavoritesOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IWebDeleteFavoritesRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchWebDeleteFavorites<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IWebDeleteFavoritesOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TWebDeleteFavoritesResponse
> {
  const { response, statusCode } = await httpApi.fetch(createWebDeleteFavoritesModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IWebDeleteFavoritesResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IWebDeleteFavoritesResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TWebDeleteFavoritesResponse;
}

export { defaultConfig, createWebDeleteFavoritesModel, fetchWebDeleteFavorites };
